import { styled, SxProps } from '@mui/system';
import { Link } from 'react-router-dom';

const NiceLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
});

interface RouterLinkProps {
  to: string;
  children: React.ReactNode;
  sx?: SxProps;
}

export default function RouterLink({ to, children, sx }: RouterLinkProps) {
  return (
    <NiceLink to={to} sx={sx}>
      {children}
    </NiceLink>
  );
}
